import { isolateComponent } from '@zapier/style-encapsulation';
import { useAlertBanner } from './useAlertBanner/useAlertBanner';
import { useCurrencies } from '@zapier/currency';
export const AlertBanner = (props) => {
    const { Component, data } = useAlertBanner({ useQuery: props.useQuery });
    const { currencies, isLoading: isLoadingCurrencies } = useCurrencies({
        useQuery: props.useQuery,
    });
    if (!Component || isLoadingCurrencies) {
        return null;
    }
    return (isolateComponent(Component, { data: data, currency: currencies === null || currencies === void 0 ? void 0 : currencies.find((c) => c.name === (data === null || data === void 0 ? void 0 : data.currentAccount.currency)), layout: "banner", trackEvent: props.trackEvent, useQuery: props.useQuery, useMutation: props.useMutation }));
};
//# sourceMappingURL=AlertBanner.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
